/** 32 random bytes in base64url (43 characters), the format the API expects for an OAuth flow. */
export function newNonce(): string {
  const b = crypto.getRandomValues(new Uint8Array(32));
  return btoa(String.fromCharCode(...b)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
